import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as API from './api/clientManagement-api';
import { DeleteClientRequest } from '../../pages/client-management/models/IClientUser';
import {Customers} from "./types";
import { GetUsersParams } from '../users/types';
import { getUsersCustomers } from './api/clientManagement-api';

export interface ClientManagementState {
    clients: Customers | undefined,
    status: 'idle' | 'loading' | 'failed';
    singleClient: any,
    isLastPage: boolean,
    customers: Customers | undefined
}

const initialState: ClientManagementState = {
    clients: undefined,
    status: 'idle',
    singleClient: {},
    isLastPage: false,
    customers: undefined
};

export const clientsGet = createAsyncThunk(
    'clientManagement/clients',
    async  (params: GetUsersParams) => {
        try {
            const response = await getUsersCustomers(
                params
            );
            return response;
            // Handle the response
        } catch (error) {
            // Handle the error
            throw error;
        }
    }
);

export const singleClientsGet = createAsyncThunk(
    'clientManagement/singleClient',
    async ({ url, token }: {  url: string, token :string }) => {
        try {
            return await API.getSingleClient(url, token);
        } catch (error) {
            throw error;
        }
    }
);

export const deleteClient = createAsyncThunk(
    'clientManagement/deleteClient',
    async ({ id, accessToken, url }: DeleteClientRequest) => {
        try {
            return await API.DeleteClient(id, accessToken, url);
        } catch (error) {
            throw error;
        }
    }
)

export const allCustomersGet = createAsyncThunk(
    'clientManagement/allCustomersGet',
    async ({ url, token }: {  url: string, token :string }) => {
        try {
            return await API.getAllCustomers(url, token);
        } catch (error) {
            throw error;
        }
    }
);

const ClientManagementSlice = createSlice({
    name: 'clientManagement',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(clientsGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(clientsGet.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.clients = payload;
            })
            .addCase(clientsGet.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(singleClientsGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(singleClientsGet.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.singleClient = payload.data
            })
            .addCase(singleClientsGet.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteClient.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteClient.fulfilled, (state, { payload }) => {
                state.status = 'idle';
            })
            .addCase(deleteClient.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(allCustomersGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(allCustomersGet.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.customers = payload;
            })
            .addCase(allCustomersGet.rejected, (state) => {
                state.status = 'failed';
            });

    },

})

export default ClientManagementSlice.reducer;
